//// Generated by Torna Api Stealer. DO NOT EDIT IT DIRECTLY!
//// @name         获取用户信息,含角色+权限
//// @author       
//// @see          https://api-doc.niushibang.net/#/view/58pE9LX3
//// 
//// @docId        58pE9LX3
//// @docUrl       https://api-doc.niushibang.net
//// @baseUrl      
//// @apiUrl       /auth/user/info
//// @envs         
////               [dev] https://b-api-dev.niushibang.net/userCenter
//// @httpMethod   POST
//// @description  
//// @createTime   2023-01-03 14:12:59
//// @lastModified 2023-01-11 14:59:42 
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiHttp } from '@/network/ApiHttp';
import { checkReply } from '../checkReply';
export var AuthUserInfo_post;
(function (AuthUserInfo_post) {
    function call(headers, params, canceller) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = __SERVER__ + "/auth/user/info";
            const reply = yield apiHttp["POST"](Object.assign({ url, params: params, headers: headers, data: undefined }, canceller === null || canceller === void 0 ? void 0 : canceller.signals()));
            return checkReply(reply);
        });
    }
    AuthUserInfo_post.call = call;
})(AuthUserInfo_post || (AuthUserInfo_post = {}));
